
export default function LocationMap() {
  return (
    <section id="ubicacion" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Info */}
          <div>
            <span className="inline-block bg-[#0A2E1F]/10 text-[#0A2E1F] text-xs font-bold uppercase tracking-wider px-4 py-1.5 rounded-full mb-6">
              Nuestra ubicación
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Visítanos en <br />Navalcarnero
            </h2>
            <p className="text-gray-600 text-base leading-relaxed mb-10 max-w-md">
              Estamos en el corazón de Navalcarnero, Madrid. Ven a conocernos y te asesoraremos personalmente sobre la mejor solución fotovoltaica para tu hogar o empresa.
            </p>

            <div className="space-y-6 mb-10">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-[#0A2E1F] flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-[#FFB800] text-xl"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 text-sm mb-1">
                    <a href="https://www.google.com/maps/search/Calle+Eras+17+Navalcarnero+Madrid+28600" target="_blank" rel="nofollow noopener noreferrer" className="hover:text-[#FF6B35] transition-colors cursor-pointer">
                      Dirección
                    </a>
                  </h4>
                  <p className="text-gray-500 text-sm">Calle Eras 17, 28600 Navalcarnero, Madrid, España</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-[#0A2E1F] flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-[#FFB800] text-xl"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 text-sm mb-1">Teléfono</h4>
                  <a href="tel:+34680254236" className="text-gray-500 text-sm hover:text-[#FF6B35] transition-colors cursor-pointer">
                    680254236
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-[#0A2E1F] flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-[#FFB800] text-xl"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 text-sm mb-1">Email</h4>
                  <a href="mailto:jyafotovoltaica@gmail.com" className="text-gray-500 text-sm hover:text-[#FF6B35] transition-colors cursor-pointer">
                    jyafotovoltaica@gmail.com
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-[#0A2E1F] flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-[#FFB800] text-xl"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 text-sm mb-1">Horario</h4>
                  <p className="text-gray-500 text-sm">Lunes a Viernes: 9:00 - 18:00</p>
                </div>
              </div>
            </div>

            <a
              href="https://www.google.com/maps/dir//Calle+Eras+17+Navalcarnero+Madrid+28600"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#FF6B35] text-white px-8 py-3.5 rounded-lg text-sm font-semibold hover:bg-[#FFB800] hover:text-gray-900 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-route-line text-lg"></i>
              Cómo llegar
            </a>
          </div>

          {/* Map */}
          <div className="rounded-3xl overflow-hidden shadow-xl shadow-black/10">
            <div className="w-full h-[500px]">
              <iframe
                title="Ubicación JyA Fotovoltaica - Calle Eras 17, Navalcarnero, Madrid"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3041.5!2d-3.9333!3d40.2833!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDE3JzAwLjAiTiAzwrA1NicwMC4wIlc!5e0!3m2!1ses!2ses!4v1700000000000!5m2!1ses!2ses&q=Calle+Eras+17,+28600+Navalcarnero,+Madrid,+Spain"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="w-full h-full"
              />
            </div>
            <div className="bg-[#0A2E1F] px-6 py-4 flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-full bg-[#FFB800] flex items-center justify-center">
                  <i className="ri-map-pin-2-fill text-gray-900 text-sm"></i>
                </div>
                <div>
                  <p className="text-white text-sm font-semibold">JyA Fotovoltaica</p>
                  <p className="text-gray-400 text-xs">C/ Eras 17, 28600 Navalcarnero, Madrid</p>
                </div>
              </div>
              <a
                href="https://www.google.com/maps/search/Calle+Eras+17+Navalcarnero+Madrid+28600"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="text-[#FFB800] text-sm font-medium hover:text-white transition-colors cursor-pointer flex items-center gap-1"
              >
                Ver en Google Maps
                <i className="ri-external-link-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
